/**
 * LoggedOutHome: the landing page for logged-out visitors, rendered at "/"
 * (ProtectedRoute, requiresLogin=false, so logged-in users are redirected away).
 * Currently just a full-size wrapper around pages/user/SignUpOrLogIn; a side-by-
 * side Explainer panel is present but commented out. No state or API calls.
 */
import SignUpOrLogin from "@/pages/user/SignUpOrLogIn";

const LoggedOutHome: React.FC = () => {
    return (
        <div className="flex flex-col md:flex-row h-full w-full overflow-hidden">
            {/* <div className="w-full md:w-1/2 h-1/2 md:h-full overflow-hidden order-2 md:order-1">
                <Explainer />
            </div> */}
            <div className="h-full w-full overflow-hidden">
                <SignUpOrLogin />
            </div>
        </div>
    );
};

export default LoggedOutHome;
